import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import Container from './container'
import styles from './header.module.scss'

const Header = ({ title, className, fluid, children }) => (
  <Container className={classnames(className, styles.header)} fluid={fluid}>
    <h1 className={styles.title}>{title}</h1>
    {children}
  </Container>
)

Header.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  fluid: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}

Header.defaultProps = {
  className: null,
  fluid: false,
  children: null
}

export default Header
